import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchOutletTypesDictionaryRequest = () => ({
  type: actionTypes.FETCH_OUTLET_TYPES_DICTIONARY_REQUEST,
});

export const fetchOutletTypesDictionarySuccess = (outletTypes) => ({
  type: actionTypes.FETCH_OUTLET_TYPES_DICTIONARY_SUCCESS,
  outletTypes,
});

export const fetchOutletTypesDictionaryFailure = () => ({
  type: actionTypes.FETCH_OUTLET_TYPES_DICTIONARY_FAILURE,
});

export const fetchOutletTypesDictionary = () => async (dispatch, getState) => {
  const { session } = getState();
  const { locale } = session;

  try {
    dispatch(fetchOutletTypesDictionaryRequest());

    const outletTypes = await api.fetchOutletTypesDictionary(locale);
    dispatch(fetchOutletTypesDictionarySuccess(outletTypes));
  } catch (error) {
    console.error('OUTLET_TYPES_DICTIONARY', error);
    dispatch(fetchOutletTypesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/outlet-types-dictionary.actions.js